<template>
  <div class="vehicle-group-dashboard-hold" v-loading="loading">
    <AlertBox
      class="mb16"
      title="车辆持有情况为准实时数据，数据更新可能存在1小时左右延迟"
      btnText="刷新数据"
      @btnClick="update"
    />

    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
         <!-- 已租车辆 -->
        <HorizontalCardStyle1
          :title="leasedData.title"
          :dataDesc="leasedData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="leasedData.primaryDataList"
          :secondaryDataList="leasedData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 待租车辆 -->
        <HorizontalCardStyle1
          :title="toLeaseData.title"
          :dataDesc="toLeaseData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="toLeaseData.primaryDataList"
          :secondaryDataList="toLeaseData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 可运营车辆 -->
        <HorizontalCardStyle1
          :title="operationalData.title"
          :dataDesc="operationalData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="operationalData.primaryDataList"
          :secondaryDataList="operationalData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 待处理车辆 -->
        <HorizontalCardStyle1
          :title="toDealData.title"
          :dataDesc="toDealData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="toDealData.primaryDataList"
          :secondaryDataList="toDealData.secondaryDataList"
        />

      </el-col>
    </el-row>
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 退出运营车辆 -->
        <HorizontalCardStyle1
          :title="exitOperationsData.title"
          :dataDesc="exitOperationsData.dataDesc"
          :dataUpdateTime="dataUpdateTime"
          :primaryDataList="exitOperationsData.primaryDataList"
          :secondaryDataList="exitOperationsData.secondaryDataList"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import AlertBox from '@/bizComponents/Dashboard/alertBox/index.vue'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox/index.vue'
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1.vue'
import { getVehicleHoldInfo } from '@/api/domain/vehicle'
import { today, thisWeek, thisMonth } from '../../config'
import { TABS } from '../../../list/config'
import { useQueryStringify } from '@/utils/useAutoQuery'

export default {
  components: {
    AlertBox,
    FiltersBox,
    HorizontalCardStyle1,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
          showRatio: true,
        },
      },
      // 数据更新时间
      dataUpdateTime: '',
      // 可运营车辆
      operationalData: {
        title: '可运营车辆',
        dataDesc: '准实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 退出运营车辆
      exitOperationsData: {
        title: '退出运营车辆',
        dataDesc: '准实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 待处理车辆
      toDealData: {
        title: '待处理车辆',
        dataDesc: '准实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 待租车辆
      toLeaseData: {
        title: '待租车辆',
        dataDesc: '准实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 已租车辆
      leasedData: {
        title: '已租车辆',
        dataDesc: '准实时数据',
        primaryDataList: [],
        secondaryDataList: [],
      },
      deptIdList: [],
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    params() {
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
      }
    },
    // 根部门ID
    rootDeptId() {
      return this.$store.getters.userInfo.rootDeptId
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
    deptIdList: {
      handler(val) {
        if (val.length) {
          const deptIdFilter = this.globalFilter.filterList.find((item) => item.name === 'deptId')
          deptIdFilter.options = val.map((item) => ({
            ...item,
            label: item.deptName,
            value: item.deptId,
          }))
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.update()
  },
  methods: {
    update() {
      this.updateCardData()
    },
    updateCardData() {
      this.loading = true
      this.getVehicleHoldInfo().finally(() => {
        this.loading = false
      })
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    // 跳转车辆-车辆列表
    toVehicleManageList({ tab, carCreateTime, times }) {
      const selectDeptId = this.globalFilter.model.deptId
      const query = {
        b: '',
        f: {
          deptIdList: (selectDeptId && selectDeptId !== this.rootDeptId) ? [this.globalFilter.model.deptId] : [],
        },
      }
      // tab '0':全部车辆 '5':待入库 '10':待处理 '20':待租 '40':已租 'outCar':退出运营
      if (typeof tab !== 'undefined') {
        query.b = String(tab)
      }

      // 车辆创建时间 ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']
      if (typeof carCreateTime !== 'undefined') {
        query.f.carCreateTime = carCreateTime
      }
      // 处置时间 ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']
      if (typeof times !== 'undefined') {
        query.f.times = times
      }
      this.$router.push(`/vehicle/vehicleManage/list?${useQueryStringify(query)}`)
    },
    async getVehicleHoldInfo() {
      const res = await getVehicleHoldInfo(this.params)
      const { code, data } = res
      if (code === 1 && data) {
        this.dataUpdateTime = data.updateTime || ''
        // 可运营车辆数据
        this.operationalData.primaryDataList = [
          {
            label: '当前累计数量',
            value: data.operational?.totalNumber || 0,
            unit: '辆',
            tooltip: '截止当前车辆状态为“待入库、待处理、待租、已租”的车辆数之和',
            // 车辆-车辆列表-全部车辆
            clickCallback: () => this.toVehicleManageList({}),
          },
        ]
        this.operationalData.secondaryDataList = [
          {
            label: '今日新增数量',
            value: data.operational?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日新添加的车辆数',
            // 车辆-车辆列表-全部车辆”，将当前日期带入“车辆创建时间”搜索条件
            clickCallback: () => this.toVehicleManageList({
              carCreateTime: today,
            }),
            ratioList: [
              {
                name: '日环比',
                value: data.operational?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.operational?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周新增数量',
            value: data.operational?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周新添加的车辆数',
            // 车辆-车辆列表-全部车辆，将本周的开始日期和结束日期带入“车辆创建时间”搜索条件
            clickCallback: () => this.toVehicleManageList({
              carCreateTime: thisWeek,
            }),
            ratioList: [
              {
                name: '周环比',
                value: data.operational?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月新增数量',
            value: data.operational?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月新添加的车辆数',
            // 车辆-车辆列表-全部车辆，将本月的开始日期和结束日期带入“车辆创建时间”搜索条件
            clickCallback: () => this.toVehicleManageList({
              carCreateTime: thisMonth,
            }),
            ratioList: [
              {
                name: '月环比',
                value: data.operational?.monthNumberRadio,
              },
            ],
          },
        ]
        // 退出运营车辆数据
        this.exitOperationsData.primaryDataList = [
          {
            label: '当前累计数量',
            value: data.exitOperations?.totalNumber || 0,
            unit: '辆',
            tooltip: '截止当前车辆状态为“退出运营”的车辆数',
            // 车辆-车辆列表-退出运营
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.OutCar,
            }),
          },
        ]
        this.exitOperationsData.secondaryDataList = [
          {
            label: '今日新增数量',
            value: data.exitOperations?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日新增退出运营车辆数',
            // 车辆-车辆列表-退出运营，将当前日期带入“处置时间”搜索条件
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.OutCar,
              times: today,
            }),
            ratioList: [
              {
                name: '日环比',
                value: data.exitOperations?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.exitOperations?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周新增数量',
            value: data.exitOperations?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周新增退出运营车辆数',
            // 车辆-车辆列表-退出运营，将本周的开始日期和结束日期带入“处置时间”搜索条件
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.OutCar,
              times: thisWeek,
            }),
            ratioList: [
              {
                name: '周环比',
                value: data.exitOperations?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月新增数量',
            value: data.exitOperations?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月新增退出运营车辆数',
            // 车辆-车辆列表-退出运营，将本月的开始日期和结束日期带入“处置时间”搜索条件
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.OutCar,
              times: thisMonth,
            }),
            ratioList: [
              {
                name: '月环比',
                value: data.exitOperations?.monthNumberRadio,
              },
            ],
          },
        ]
        // 待处理车辆数据
        this.toDealData.primaryDataList = [
          {
            label: '当前累计数量',
            value: data.toDeal?.totalNumber || 0,
            unit: '辆',
            tooltip: '截止当前车辆状态为“待处理”的车辆数',
            // 车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
          },
        ]
        this.toDealData.secondaryDataList = [
          {
            label: '今日新增数量',
            value: data.toDeal?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日新增经历过待处理状态的车辆数',
            // 车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
            ratioList: [
              {
                name: '日环比',
                value: data.toDeal?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.toDeal?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周新增数量',
            value: data.toDeal?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周新增经历过待处理状态的车辆数',
            // 车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
            ratioList: [
              {
                name: '周环比',
                value: data.toDeal?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月新增数量',
            value: data.toDeal?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月新增经历过待处理状态的车辆数',
            // 车辆-车辆列表-待处理
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForHandle,
            }),
            ratioList: [
              {
                name: '月环比',
                value: data.toDeal?.monthNumberRadio,
              },
            ],
          },
        ]
        // 待租车辆数据
        this.toLeaseData.primaryDataList = [
          {
            label: '当前累计数量',
            value: data.toLease?.totalNumber || 0,
            unit: '辆',
            tooltip: '截止当前车辆状态为“待租”的车辆数',
            // 车辆-车辆列表-待租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForRent,
            }),
          },
        ]
        this.toLeaseData.secondaryDataList = [
          {
            label: '今日新增数量',
            value: data.toLease?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日新增经历过待租状态的车辆数',
            // 车辆-车辆列表-待租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForRent,
              carCreateTime: today,
            }),
            ratioList: [
              {
                name: '日环比',
                value: data.toLease?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.toLease?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周新增数量',
            value: data.toLease?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周新增经历过待租状态的车辆数',
            // 车辆-车辆列表-待租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForRent,
              carCreateTime: thisWeek,
            }),
            ratioList: [
              {
                name: '周环比',
                value: data.toLease?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月新增数量',
            value: data.toLease?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月新增经历过待租状态的车辆数',
            // 车辆-车辆列表-待租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.WaitForRent,
              carCreateTime: thisMonth,
            }),
            ratioList: [
              {
                name: '月环比',
                value: data.toLease?.monthNumberRadio,
              },
            ],
          },
        ]
        // 已租车辆数据
        this.leasedData.primaryDataList = [
          {
            label: '当前累计数量',
            value: data.leased?.totalNumber || 0,
            unit: '辆',
            tooltip: '截止当前车辆状态为“已租”的车辆数',
            // 车辆-车辆列表-已租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.AfterRent,
            }),
          },
        ]
        this.leasedData.secondaryDataList = [
          {
            label: '今日新增数量',
            value: data.leased?.todayNumber || 0,
            unit: '辆',
            tooltip: '今日新增经历过已租状态的车辆数',
            // 车辆-车辆列表-已租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.AfterRent,
              carCreateTime: today,
            }),
            ratioList: [
              {
                name: '日环比',
                value: data.leased?.todayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.leased?.todayNumberWeekYoY,
              },
            ],
          },
          {
            label: '本周新增数量',
            value: data.leased?.weekNumber || 0,
            unit: '辆',
            tooltip: '本周新增经历过已租状态的车辆数',
            // 车辆-车辆列表-已租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.AfterRent,
              carCreateTime: thisWeek,
            }),
            ratioList: [
              {
                name: '周环比',
                value: data.leased?.weekNumberRadio,
              },
            ],
          },
          {
            label: '本月新增数量',
            value: data.leased?.monthNumber || 0,
            unit: '辆',
            tooltip: '本月新增经历过已租状态的车辆数',
            // 车辆-车辆列表-已租
            clickCallback: () => this.toVehicleManageList({
              tab: TABS.AfterRent,
              carCreateTime: thisMonth,
            }),
            ratioList: [
              {
                name: '月环比',
                value: data.leased?.monthNumberRadio,
              },
            ],
          },
        ]
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
</style>
